import React from "react";
import ReactDOM from "react-dom";
import "promise-polyfill/src/polyfill";
import "whatwg-fetch";
import LoginPage from "./components/LoginPage";

ReactDOM.render(<LoginPage />, document.getElementById("login-container"));



// WEBPACK FOOTER //
// ./src/index.js